// extracted by mini-css-extract-plugin
export default {"protocolIcon":"styles_protocolIcon__WD1mf","acquisitionLink":"styles_acquisitionLink__kUMEL"};